import React from 'react';
import { Row, Col } from 'react-bootstrap';
import _ from 'lodash';

import FieldTextAreaWithRating from './FieldTextAreaWithRating.jsx';

const fields = [
  {
    label: 'Side Bite',
    description: 'Describe car on corner entry: loose, tight, etc.',
    field: 'sideBite',
    dropdownDescriptions: {
      10: 'Exceptional',
    },
  },
  {
    label: 'Drive Off',
    description: 'Describe car on corner exit: loose, tight, etc.',
    field: 'driveOff',
    dropdownDescriptions: {
      10: 'Exceptional',
    },
  },
  {
    label: 'Speed',
    description: 'Describe speed related to engine',
    field: 'speed',
    dropdownDescriptions: {
      1: 'Terrible',
      10: 'Exceptional',
    },
  },
  {
    label: 'Car Stability',
    description: 'Describe car stability: bicycling, body roll, etc.',
    field: 'carStability',
    dropdownDescriptions: {
      10: 'Exceptional',
    },
  },
  {
    label: 'Motor',
    description: 'Describe motor: stumble, vibration, responsiveness, etc.',
    field: 'motor',
    dropdownDescriptions: {
      1: 'Unresponsive',
      10: 'Exceptional',
    },
  },
];

const overrideOptions = [
  { slug: 1, value: '1 - Poor' },
  { slug: 2, value: '2 - Below Average' },
  { slug: 3, value: '3 - Average' },
  { slug: 4, value: '4 - Above Average' },
  { slug: 5, value: '5 - Exceptional' },
];

export default function DirtDetails() {
  return (
    <div id="section-dirt-details">
      <h4 className="rating-type">Race</h4>
      <p className="subtext">All information given is confidential and will not be shared with any group outside of TRD.</p>

      <Row>
        {fields.map((question, i) => (
          <Col xs={12} sm={6} key={question.field}>
            <FieldTextAreaWithRating
              label={`${(i + 1)}) ${question.label}`}
              description={(question.description) ? `${question.description}` : null}
              ratingField={`${question.field}.rating`}
              textAreaField={`${question.field}.feedback`}
              placeholder="Feedback"
              nonTrackRating={true}
              dropdownDescriptions={_.get(question, 'dropdownDescriptions')}
              overrideOptions={overrideOptions}
              overrideDefaultValue={5}
            />
          </Col>
        ))}
      </Row>
    </div>
  );
}
